// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosPromise } from 'axios';

import { authGet, authPost, parseCamelCase, parseSnakeCase } from './util';
import { Progress } from '../types/Model';

export const getOnlineCourseData = (id: string): AxiosPromise => {
  return authGet(`/course/onlineCourses/${id}/information`, {
    transformResponse: (onlineCourse: any) => parseCamelCase(onlineCourse)
  });
};

export const getOnlineCourseFeedback = (id: string): AxiosPromise => {
  return authGet(`/course/onlineCourses/${id}/reviews`, {
    transformResponse: (data: any) => ({
      canReview: data.data.can_review,
      list: data.list.map((review: any) => ({
        avatar: review.image_url,
        username: review.username,
        rating: review.rate,
        comments: review.comment
      }))
    })
  });
};

export const postOnlineCourseFeedback = (
  id: string,
  payload: any
): AxiosPromise => {
  return authPost(`/course/onlineCourses/${id}/reviews`, payload);
};

export const getOnlineCourseRelated = (id: string): AxiosPromise => {
  return authGet(`/course/onlineCourses/${id}/related`, {
    transformResponse: (data: []) => {
      return parseCamelCase(data)
    }
  });
};

interface UpdateProgress {
  revisedTime: Date;
  progress: Progress[];
}

export const updateProgress = (id: number, progress: any): AxiosPromise<UpdateProgress> => {
  return authPost(`/course/onlineCourses/${id}/progress`, parseSnakeCase(progress), {
    transformResponse: (data: any) => parseCamelCase(data)
  })
}

export const updateViewHistory = (onlineCourseId: number): AxiosPromise => {
  return authPost('/course/viewHistory', parseSnakeCase({ onlineCourseId }));
};
